import { Button, type ButtonProps, MenuButton as ChakraMenuButton } from '@/ui';

export const DefaultsMenuButton = (props: ButtonProps) => {
  return (
    <ChakraMenuButton
      _hover={{ bg: 'gray.200' }}
      as={Button}
      bg="gray.100"
      colorScheme="dark"
      fontWeight="normal"
      h="34px"
      minW="auto"
      p="3"
      variant="ghost"
      {...props}
    />
  );
};
